'use strict';

var react = require('react');
var useSafeLayoutEffect = require('../useSafeLayoutEffect/useSafeLayoutEffect.js');

/**
 * This hooks keeps track of a value, but not trigger re-render when the value is update it.
 * @see inspired from https://epicreact.dev/the-latest-ref-pattern-in-react/
 */ function useLatestRef(value) {
    const ref = react.useRef(value);
    // using a useSafeLayoutEffect instead of a useEffect because we need to update this value and make sure it's up-to-date before any other code runs
    // https://kentcdodds.com/blog/useeffect-vs-uselayouteffect#one-special-case
    useSafeLayoutEffect.useSafeLayoutEffect(()=>{
        ref.current = value;
    });
    return ref;
}

exports.useLatestRef = useLatestRef;
//# sourceMappingURL=useLatestRef.js.map
